import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "../components/Projects/ProjectCard";
import Particle from "../components/Particle";
import ecommerce from "../assets/projects/ecommerce.png"
import booking from "../assets/projects/booking.png"
import blog from "../assets/projects/blog.png"
import news from "../assets/projects/news.png"
import todo from "../assets/projects/todo.jpg"

const Projects = () => {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          Recent Top <strong className="yellow">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={ecommerce}
              isBlog={false}
              title="E‑Commerce Website"
              description="This ecommerce website utilizes a REST API built with Nodejs and Expressjs, allowing for easy CRUD operations on user profiles, products and admin panel. The user interface is designed for efficient product management and includes a complete purchase process. The admin panel, accessible for CRUD on users and products. Braintree API is integrated to handle customer payments. The website uses MongoDB as the database."
              ghLink="https://github.com/Gourav-M-i/MERN-Ecommerce-Web-App"
              demoLink="https://ecommerce-frontend-pi-swart.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={booking}
              isBlog={false}
              title="Hotel Booking"
              description="This platform features a Hotel Booking website, allowing users to easily book hotel rooms.It also has an interactive admin panel which allows to add, delete and view hotels, rooms and users."
              ghLink="https://github.com/Gourav-M-i/hotel-booking"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={blog}
              isBlog={false}
              title="Blog Website"
              description="This blogging application features a RESTful API server built with Nodejs and Expressjs. The data is retrieved from the API server and displayed on a user-friendly interface designed using React for a seamless experience."
              ghLink="https://github.com/Gourav-M-i/MERN-Blog-Web-App"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={news}
              isBlog={false}
              title="News Android App"
              description="A news android app deveoped using ReactNative that uses newsapi to fetch latest news and display news category wise."
              ghLink="https://github.com/Gourav-M-i/News-Android-App"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={todo}
              isBlog={false}
              title="Todo Android App"
              description="A todo list android app developed using Reactnative that uses firebase for authentication and databse."
              ghLink="https://github.com/Gourav-M-i/Todo-Android-App"
            />
          </Col>

        </Row>
      </Container>
    </Container>
  )
}

export default Projects